import { HqoClientSdk, SdkEvents } from '@hqo/hqo-miniapp-client-sdk';
import { useMiniappSdkEventHandler } from 'app/shared/hooks/use-miniapp-sdk/use-miniapp-sdk.hooks';
import { useMiniappSdk } from 'app/shared/contexts/miniapp-sdk';
import { Paper } from 'app/components/ui/paper';
import { Button } from '@hqo/ui-atoms';
import React, { useCallback, useState } from 'react';

type RootActions = keyof Pick<HqoClientSdk, 'refreshToken' | 'redirectToContent'>;

interface MiniappSdkRootMethodDemoProps {
  action: RootActions;
  eventName: SdkEvents;
  children?: React.ReactNode;
  args?: unknown[];
}

export const MiniappSdkRootMethodDemo = ({
  action,
  eventName,
  children,
  args = [],
}: MiniappSdkRootMethodDemoProps): JSX.Element => {
  const [eventData, setEventData] = useState<string | null>(null);
  const client = useMiniappSdk();

  useMiniappSdkEventHandler(
    eventName,
    (data: unknown) => {
      setEventData(JSON.stringify(data, null, 2));
    },
    [setEventData],
  );

  const handleClick = useCallback(() => {
    switch (action) {
    case 'refreshToken':
      client.refreshToken();
      break;
    case 'redirectToContent':
      client.redirectToContent(args[0] as Parameters<HqoClientSdk['redirectToContent']>[0]);
      break;
    default:
      break;
    }
  }, [action, args, client]);

  return (
    <Paper className="flex flex-col p-2 gap-2 items-start overflow-x-hidden">
      <Button
        onClick={handleClick}
        className="h-auto"
        variant="default"
      >
        {action}
      </Button>
      {children}
      <div className="flex flex-col overflow-x-scroll w-full">
        <pre className="text-sm">{eventData}</pre>
      </div>
    </Paper>
  );
};
